export default {
  // 2-16
  GET_ORGCHOICE_LIST(state, res) {
    const data = JSON.parse(JSON.stringify(res.data));
    data.forEach((e) => {
      if (e.total == 0) {
        e.po_Name = "(未入會) " + e.po_Name;
      } else {
        e.po_Name = "(已入會) " + e.po_Name;
      }
    });
    state.org_choicelist = data;
  },
  GET_ORGAPPLIER_DATA(state, res) {
    const data = JSON.parse(JSON.stringify(res.data));
    data.forEach((e, index) => {
      e.index = index + 1;
      e.protocolInfo = "";
      let fslist = [];
      if (e.f_Authorization == "Y") {
        fslist.push("主包");
      }
      if (e.s_Authorization == "Y") {
        fslist.push("下包");
      }
      e.authorization = fslist.join(" ");
      e.approve_Status2 = e.status;
    });
    state.org_applier = data;
    state.org_applierlist = state.org_applier.slice(0, 10);
  },

  // 2-17
  GET_ORGCENSOR_DATA(state, res) {
    const data = JSON.parse(JSON.stringify(res.data));
    data.forEach((e, index) => {
      e.index = index + 1;
      if (!e.in_Date && !e.out_Date) {
        e.period = "無";
      } else {
        e.period = `${e.in_Date}~${e.out_Date}`;
      }
      e.sInfo = `${e.s_Name} ${e.s_Id}`;

      e.protocolInfo = "";
      let fslist = [];
      if (e.f_Authorization == "Y") {
        fslist.push("主包");
      }
      if (e.s_Authorization == "Y") {
        fslist.push("下包");
      }
      e.authorization = fslist.join(" ");
    });
    state.org_forcensor = data;
    state.org_forcensorlist = state.org_forcensor.slice(0, 10);
  },
};
